"use client";

import { useSearchParams, useRouter, usePathname } from "next/navigation";

const CategoryButton = ({category, children}: {category: string, children: React.ReactNode}) => {
    const searchParams = useSearchParams();
    const router = useRouter();
    const pathname = usePathname();

    const currentCategory = searchParams.get("category") || "";
    const isActive = currentCategory === category;

    const handleClick = () => {
        const params = new URLSearchParams(searchParams.toString());
        if (isActive) {
            params.delete("category");
        } else {
            params.set("category", category);
        }
        router.push(`${pathname}?${params.toString()}`);
    };

    return (
        <button 
            onClick={handleClick}
            className={`whitespace-nowrap text-sm px-4 py-2 rounded-full border transition-all cursor-pointer ${isActive ? 'bg-wosm-default text-white border-transparent' : 'bg-white border-wosm-default bg-white'}`}
        >
            {children}
        </button>
    );
};

export default CategoryButton;